module.exports = __webpack_public_path__ + "df5aebee7d31872a6f6e87c2997f3785.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/owl-item-types/face.png
// module id = 1724
// module chunks = 0